import { render, staticRenderFns } from "./ClientStockRateSearchBarComponent.vue?vue&type=template&id=b0f45862"
import script from "./ClientStockRateSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ClientStockRateSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientStockRateSearchBarComponent.vue?vue&type=style&index=0&id=b0f45862&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports